module.exports = __webpack_public_path__ + "static/media/tanqueTVL.48ec4665.jpg";